// Minimal, privacy-safe analytics for CampoDirecto.
// - Only sends whitelisted properties (source, selected_role, current_role,
//   required_role, language, redirect_path). Any extra key is dropped.
// - Never blocks navigation: fire-and-forget with best-effort transport.
// - Failures are swallowed silently.
import { api } from "./api";

const ALLOWED_PROPS = new Set([
    "source",
    "selected_role",
    "current_role",
    "required_role",
    "language",
    "redirect_path",
]);

const KNOWN_EVENTS = new Set([
    "homepage_sell_clicked",
    "homepage_buy_clicked",
    "homepage_transport_clicked",
    "productor_registration_started",
    "comprador_registration_started",
    "transportista_registration_started",
    "registration_completed",
    "login_completed",
    "product_creation_started",
    "buyer_request_started",
    "available_loads_opened",
]);

function sanitize(props) {
    if (!props || typeof props !== "object") return {};
    const out = {};
    for (const k of Object.keys(props)) {
        if (!ALLOWED_PROPS.has(k)) continue;
        const v = props[k];
        if (v === null || v === undefined) continue;
        // Only accept short primitive strings/numbers/booleans.
        if (typeof v === "string" && v.length <= 200) out[k] = v;
        else if (typeof v === "number" || typeof v === "boolean") out[k] = v;
    }
    return out;
}

export function track(event, props = {}) {
    if (!event || typeof event !== "string") return;
    if (!KNOWN_EVENTS.has(event)) return;
    const payload = { event, props: sanitize(props), language: "es-MX" };
    try {
        // Non-blocking: do not await. Timeout kept short by axios instance.
        api.post("/analytics/event", payload).catch(() => {});
    } catch (_) { /* swallow */ }
}
